import { render, staticRenderFns } from "./PosSidebar.vue?vue&type=template&id=40b95c5c&scoped=true&"
import script from "./PosSidebar.vue?vue&type=script&lang=js&"
export * from "./PosSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PosSidebar.vue?vue&type=style&index=0&id=40b95c5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b95c5c",
  null
  
)

export default component.exports